import { seededShuffle } from "../common/numbers";
import Term from "../term/Term";
import LearningContinue from "./LearningContinue";

export default class LearningContinueResult {
  terms: Term[];
  learningContinue: LearningContinue;

  constructor(terms: Term[], learningContinue: LearningContinue) {
    this.terms = terms;
    this.learningContinue = learningContinue;
  }

  static fromJson(json: any): LearningContinueResult {
    const learningContinue = LearningContinue.fromJson(json.learningContinue);
    const termsJsonData = json.terms;
    const terms = termsJsonData.map((termData: any) => Term.fromJson(termData));
    const sortedTerms = [...terms].sort((a, b) => a.id.localeCompare(b.id));
    let shuffledTerms: Term[] = [];
    shuffledTerms = seededShuffle(sortedTerms, learningContinue.seed);
    return new LearningContinueResult(shuffledTerms, learningContinue);
  }
}
